import { useEffect, lazy, Suspense } from "react";
import ErrorBoundary from "@/components/portfolio/ErrorBoundary";
import { SectionSkeleton } from "@/components/portfolio/Skeletons";
import Navbar from "@/components/portfolio/Navbar";
import Hero from "@/components/portfolio/Hero";
import Stats from "@/components/portfolio/Stats";
import About from "@/components/portfolio/About";
import Currently from "@/components/portfolio/Currently";
import EditorialMarquee from "@/components/portfolio/EditorialMarquee";
import { FooterReveal } from "@/components/portfolio/Footer";
import useScrollStage from "@/hooks/useScrollStage";
// Lazy load below-the-fold components to reduce initial JS payload
const Skills = lazy(() => import("@/components/portfolio/Skills"));
const Experience = lazy(() => import("@/components/portfolio/Experience"));
const Projects = lazy(() => import("@/components/portfolio/Projects"));
const GitHubSection = lazy(() => import("@/components/portfolio/GitHubSection"));
const LeetCode = lazy(() => import("@/components/portfolio/LeetCode"));
const Blog = lazy(() => import("@/components/portfolio/Blog"));
const ResumeSection = lazy(() => import("@/components/portfolio/ResumeSection"));
const Contact = lazy(() => import("@/components/portfolio/Contact"));

export default function Portfolio() {
  const cinematic = useScrollStage();
  useEffect(() => {
    document.title = "Tanishq Saini — Software Developer";
  }, []);

  return (
    <main data-testid="portfolio-page">
      <Navbar />
      <Hero />
      {!cinematic && <About />}
      <div
        className="relative"
        style={{ backgroundImage: "radial-gradient(ellipse 90% 55% at 50% 47%, rgb(var(--brand-500) / 0.08), transparent 75%), linear-gradient(to bottom, #08090b 0%, #08090b 72%, #050505 100%)" }}
      >
        <Stats />
        <Currently />
        <EditorialMarquee />
      </div>
      <ErrorBoundary>
      <Suspense fallback={<SectionSkeleton />}>
        <div
          className="cv-auto"
          style={cinematic ? { background: "linear-gradient(to bottom, #050505 0%, #050505 35%, #0c0d0e 100%)" } : undefined}
        >
          <Skills />
        </div>
        <div className="cv-auto">
          <Experience />
        </div>
        <div className="cv-auto">
          <Projects />
        </div>
        <div
          className="cv-auto"
          style={cinematic ? { background: "linear-gradient(to bottom, #0c0d0e 0%, #050505 100%)" } : undefined}
        >
          <GitHubSection />
        </div>
        <div className="cv-auto">
          <LeetCode />
        </div>
        <div className="cv-auto">
          <ResumeSection />
        </div>
        <div className="cv-auto">
          <Blog />
        </div>
        <div className="cv-auto">
          <FooterReveal><Contact /></FooterReveal>
        </div>
      </Suspense>
      </ErrorBoundary>
    </main>
  );
}
